//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import wx from 'weixin-js-sdk'; 
export default {
  name: 'pickup',
  components: {
  },
  data () {
    return {
      id:0,
      i:0,
      code:'',
      order:{},
      type:0,
    }
  },
  created(){
    this.config();
  },
  mounted(){
      this.i = Number(this.$route.params.i);
      switch(this.i){
        case 1:
            this.$route.meta.title = '打包';
            break;
        case 2:
            this.$route.meta.title = '出厂';
            break;
        default:
            this.$route.meta.title = '入厂';
            break;
      }
      document.title = this.$route.meta.title;
  },
  methods:{
    copy(val){
        this.$func.copy(val,event);
    },
    scanQRCode(e){
        let that = this;
        this.type = e;
        wx.ready(()=> {
            wx.scanQRCode({
            needResult: 1,
            scanType: ["barCode"],
            success: function (res) {
                setTimeout(()=>{
                    // that.formData[id] = that.$func.parseScanResult(res.resultStr);
                    that.code = that.$func.parseScanResult(res.resultStr);
                    that.getOrder();
                },300);
            }
            })
        });
        wx.error((res)=> {
            console.log(res)
            // alert(res.errMsg);
        })
    },  
    config(){
        let url = (window.location.href).split('#');
        if(url[0].indexOf('?') != '-1'){
            url = url[0].split('?');
        }
        this.$api.wxSign({url:url[0]}).then((res)=>{
            if(res){
                wx.config({
                    debug: false, 
                    appId: res.data.appId,
                    timestamp: res.data.timestamp,
                    nonceStr: res.data.nonceStr,
                    signature:res.data.signature,
                    jsApiList: [
                        "scanQRCode"
                    ]
                });
            }
        })
    },
    getOrder(){
      //  this.$func.showToast(this.code);
      // return;
      let that = this;
      if(!this.code){
        that.$func.showToast('衣物条码无效');
        return ;
      }
      // if(code.length != 12){
      //   that.$func.showToast('子订单码无效');
      //   return ;
      // }
      that.$func.startLoading();
      console.log(this.code);
      this.$api.inFactory({code:this.code,i:this.i}).then((res)=>{
        if(res){
          that.$func.endLoading();
          that.order = res.data;
          that.$func.showToast('操作成功');
          wx.ready(function () {
              let media = document.getElementById("musicBox");
              media.src = "https://fcwash.uunbiot.com/uploads/default/operate.mp3"
              media.play();
          });
          if(that.type > 0){
            setTimeout(() => {
              that.code = '';
              that.scanQRCode(that.type);
            }, 300);
          }
        } 
      })  
    },
  }
}



// WEBPACK FOOTER //
// ./src/pages/inFactory.vue